<template>
  <div class="tableFixHead">
    <table class="table align-middle table-row-dashed fs-6 fw-bold gy-4" id="datatable_variation">
      <thead class="fw-bold fs-6" style="background-color: #F2F3F4;">
      <tr class="fw-bolder fs-7 text-uppercase text-center gs-0">
        <th class="text-center capitalize" >{{ $t('expenses.user.name') }}</th>
        <th class="text-center capitalize" >{{ $t('expenses.status.waitApprobation') }}</th>
        <th class="text-center capitalize" >{{ $t('expenses.status.waitValidation') }}</th>
        <th class="text-center capitalize" >{{ $t('expenses.status.validated') }}</th>
      </tr>
      </thead>
      <tbody :id="id" v-if="loading">
      <tr
          style="height :40vh !important;width: 100%!important;">
        <td colspan="4" >
          <div class="h-200px d-flex justify-content-center align-items-center">
            <div class="text-center">
              <div class="spinner-border" role="status">
                <span class="visually-hidden">{{ $t("loadingText") }}</span>
              </div>
            </div>
          </div>
        </td>
      </tr>
      </tbody>
      <tbody :id="id" v-else-if="!usersExpenses.length">
      <tr
          style="height :40vh !important;width: 100%!important;">
        <td colspan="3" >
          <div class=" text-center ">
            <div class="pt-8 ">
              <Img filename="empty.png" alt=""
                   class="mw-100 h-125px h-sm-175px" />
            </div>
            <h2 class="fs-2x fw-bolder mb-0">{{ $t('expenses.noUsersWithInvalidatedExpenses') }}</h2>
          </div>
        </td>
      </tr>
      </tbody>
      <tbody v-else :id="id">
      <tr @click.prevent="goToExpensesUserView(user?.id)" v-for="user in usersExpenses" :key="user.id" style="cursor: pointer;">
        <td class="text-center">
          {{ user.firstname }} {{ user.lastname }}
        </td>
        <td class="text-center text-danger">
          {{ (user.user_expenses_unapproved_count) }}
        </td>
        <td class="text-center text-danger">
          {{ (user.user_expenses_unvalidated_count) }}
        </td>
        <td class="text-center text-success">
          {{ (user.user_expenses_validated_count) }}
        </td>
      </tr>
      </tbody>
    </table>
  </div>

</template>

<script setup>
import {onMounted, ref, computed, watch, nextTick} from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import Button from "@/components/Button.vue";
import Img from "@/components/Img.vue";

const router = useRouter()
const route = useRoute()

const office = route.params.id
const company = route.params.company

const props = defineProps({
  loading: { type: Boolean, default: true },
  usersExpenses: {type: Array, default: () => ([])},
  id: {type: String, default: 'kt_td_picker_button'},
  officeId: { type: String, default: '' }
})

const goToExpensesUserView = (id) => {
  router.push({name:"office-users-expenses-list", params:{id, office: props.officeId, company}})
}

const goToOfficeView = (id) => {
  router.push({name:"office-expenses", params:{id, office: props.officeId, company}})
}


onMounted(() => {
})

</script>
